module.exports = __webpack_public_path__ + "img/theme11.e0e153b7.png";